import { render, staticRenderFns } from "./LeftSku.vue?vue&type=template&id=d4f92c34"
import script from "./LeftSku.vue?vue&type=script&lang=js"
export * from "./LeftSku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4f92c34')) {
      api.createRecord('d4f92c34', component.options)
    } else {
      api.reload('d4f92c34', component.options)
    }
    module.hot.accept("./LeftSku.vue?vue&type=template&id=d4f92c34", function () {
      api.rerender('d4f92c34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/source/components/AppointDelivery/parcel/LeftSku.vue"
export default component.exports